var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ComposerAnalyticsEvent, ComposerMode } from '../types/index';
import { EventSeriesOption, } from './useEvent/useEventTypes';
import { buildUpdateEventPayload, shouldUpdateAsSpace, } from '../utils/payloadBuilders';
import { getRecurrenceKey } from '../components/RecurrenceDropdown/utils';
export var useHandleEventUpdate = function (_a) {
    var formData = _a.formData, timezone = _a.timezone, initialEvent = _a.initialEvent, calendarType = _a.calendarType, calendarMailboxAddress = _a.calendarMailboxAddress, updateEvent = _a.updateEvent, declineRemovedSpaces = _a.declineRemovedSpaces, setRecurringEventToUpdate = _a.setRecurringEventToUpdate, onError = _a.onError, onClose = _a.onClose, onSubmit = _a.onSubmit, onTrackComposerEvent = _a.onTrackComposerEvent;
    var t = useTranslation('meetingRooms').t;
    var handleEventUpdate = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedEvent, recurrenceValueChanged, updateAsSpace_1, declinesSucceeded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(formData === null || formData === void 0 ? void 0 : formData.eventId)) {
                        onError(new Error(t('update_event.no_event_id_found')));
                        return [2 /*return*/];
                    }
                    updatedEvent = buildUpdateEventPayload({
                        formData: formData,
                        timezone: timezone,
                        calendarType: calendarType,
                        calendarMailboxAddress: calendarMailboxAddress,
                    });
                    recurrenceValueChanged = getRecurrenceKey(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.recurrenceRule) !==
                        getRecurrenceKey(updatedEvent === null || updatedEvent === void 0 ? void 0 : updatedEvent.recurrence);
                    if (!updatedEvent) return [3 /*break*/, 3];
                    updateAsSpace_1 = shouldUpdateAsSpace(initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.eventPermissions);
                    if (!((initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.seriesId) && !recurrenceValueChanged)) return [3 /*break*/, 1];
                    // Declines run in UpdateRecurringEventModal instead, after the user
                    // confirms a series option. Declining here would mutate the event
                    // even if the user cancels the modal.
                    setRecurringEventToUpdate(updatedEvent);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, declineRemovedSpaces()];
                case 2:
                    declinesSucceeded = _a.sent();
                    if (!declinesSucceeded) {
                        return [2 /*return*/];
                    }
                    updateEvent(updatedEvent, formData.eventId, timezone, recurrenceValueChanged
                        ? EventSeriesOption.ALL_EVENTS
                        : EventSeriesOption.THIS_EVENT, updateAsSpace_1, recurrenceValueChanged)
                        .then(function (res) {
                        if (!res) {
                            onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                                mode: ComposerMode.EDIT,
                            });
                            onError(new Error('No response from updateEvent'));
                            onClose();
                            return;
                        }
                        onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_UPDATED, {
                            updatedAsSpace: updateAsSpace_1,
                            recurring: false,
                        });
                        onSubmit(res.data, ComposerMode.EDIT);
                        onClose();
                    })
                        .catch(function () {
                        // updateEvent already calls onError before re-throwing; swallow to avoid unhandled rejection
                        onTrackComposerEvent === null || onTrackComposerEvent === void 0 ? void 0 : onTrackComposerEvent(ComposerAnalyticsEvent.EVENT_SYNC_FAILED, {
                            mode: ComposerMode.EDIT,
                        });
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        formData,
        timezone,
        initialEvent,
        calendarType,
        calendarMailboxAddress,
        updateEvent,
        declineRemovedSpaces,
        setRecurringEventToUpdate,
        onError,
        onClose,
        onSubmit,
        onTrackComposerEvent,
        t,
    ]);
    return { handleEventUpdate: handleEventUpdate };
};
